import { StorePersistenceInterface } from './interfaces';

export class StorePersistenceServerService implements StorePersistenceInterface {
  load() {
    return {};
  }

  save() {}
}
